import { render, staticRenderFns } from "./Workers.vue?vue&type=template&id=6b15d408&lang=html&"
import script from "./Workers.vue?vue&type=script&lang=js&"
export * from "./Workers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports